import { produce } from "immer"
import styles from "../contact-styles.module.css"

export interface Input {
  size: number;
}

static declare global {
  namespace Marko {
    namespace CSS {
      interface Properties {
        "--size"?: number;
      }
    }
  }
}

static function tilt(i: number, j: number, flips: number) {
  const n = Math.sin(i * 78.233 + j * 37.719 + flips * 55.137) * 43758.5;
  return (n - Math.floor(n) - 0.5) * 2;
}

static const SLICES = 12;
static const BODY = Array.from({ length: SLICES }, (_, i) => {
  const angle = Math.PI * (i / (SLICES - 1) - 0.5);
  const through = Math.sin(angle);
  return {
    z: through * 0.98,
    out: Math.cos(angle).toFixed(4),
    mix: `${Math.round((through + 1) * 50)}%`,
  };
});

const/{ size }=input

let/tiles=Array.from({ length: size }, () =>
  Array.from({ length: size }, () => ({ flips: 0, di: 0, dj: 0 })),
)

let/_focused=0
let/focused=_focused
  ,valueChange(v) {
    _focused = v;
    [...$cell][v].focus();
  }

div class=styles.grid style={ "--size": size }
  for|row, i| of=tiles
    for|{ flips, di, dj }, j| of=row
      button/$cell
        ,class=styles.cell
        ,tabindex=(i * size + j === focused ? 0 : -1)
        ,onFocus() {
          _focused = i * size + j;
        }
        ,onKeyDown(e) {
          const wrap = (n: number) => (n + size) % size;
          switch (e.key) {
            case "ArrowRight":
              focused = i * size + wrap(j + 1);
              break;
            case "ArrowLeft":
              focused = i * size + wrap(j - 1);
              break;
            case "ArrowDown":
              focused = wrap(i + 1) * size + j;
              break;
            case "ArrowUp":
              focused = wrap(i - 1) * size + j;
              break;
            case "Home":
              focused = e.ctrlKey ? 0 : i * size;
              break;
            case "End":
              focused = e.ctrlKey ? size * size - 1 : i * size + size - 1;
              break;
            default:
              return;
          }
          e.preventDefault();
        }
        ,onClick() {
          tiles = produce(tiles, (tiles) => {
            for (let di = -1; di <= 1; di++) {
              for (let dj = -1; dj <= 1; dj++) {
                if (di === 0 && dj === 0) continue;

                const tile = tiles[i + di]?.[j + dj];
                if (tile) {
                  tile.flips++;
                  tile.di = di;
                  tile.dj = dj;
                }
              }
            }
          })
        }
        ,aria-label=`${i} ${j}`
        ,aria-pressed=flips % 2 ? "true" : "false"
        span
          ,class=(
            flips
              ? [styles.flipping, flips % 2 ? styles.toBack : styles.toFront]
              : styles.faceUp
          )
          ,style=`--tilt:${tilt(i, j, flips - 1)}deg; --tilt-after-flip:${tilt(i, j, flips)}deg; --flip-axis:${di && dj !== di ? `${di}, 0` : `0, ${-dj}`}, 0`
          if=flips
            for|{ z, out, mix }| of=BODY
              span class=styles.slice style=`--z:${z}; --out:${out}; --mix:${mix}`

      <script>
        if (flips) {
          for (const animation of $cell().getAnimations({ subtree: true })) {
            animation.currentTime = 0;
          }
        }
      </script>

return=BigInt("0b" + tiles.map(row => row.map(({ flips }) => flips % 2).join('')).join(''))
